<div class="absolute-center">

  <div class="fwe-d-flex">
    <div>
      <div class="label-404">404</div>
      <div class="headline">{{ 'MISC.404_ERROR' | translate }}</div>
    </div>

    <ecn-app-error-page-robot />

  </div>
  <div class="description">{{ 'MISC.404_DESCRIPTION' | translate }}</div>
  <div class="startpagebutton"><a class="fwe-btn fwe-btn-hero fwe-ml-auto" role="button" [routerLink]="['/']">{{ 'MISC.404_RETURN_TO_THE_STARTPAGE' | translate }}</a></div>
</div>
